<template>
  <div class="profile-edit wrapper">
    <h1 class="profile-edit__title">{{ trans.get('profile:edit.header') }}</h1>
    <div class="row">
      <div class="col-12">
        <CollapsedGalleryComponent :user="user"></CollapsedGalleryComponent>
        <div class="row">
          <div class="col-12">
            <VerificationStatusButton></VerificationStatusButton>
          </div>
        </div>

        <form @submit.prevent="submitForm">
          <div class="row mt-4" v-if="form && form.attributes">
            <div class="col-12 col-md-6 col-xl-4 ">
              <div class="form-group profile-edit__name">
                <label for="name">{{ trans.get('profile:edit.nick_name_lable') }} </label>
                <input
                  v-model="form.name"
                  type="text"
                  id="name"
                  name="name"
                  class="input-text input-text__underline"
                  readonly
                >
                <error-component :errors="formErrors" field='name'></error-component>
              </div>
              <div class="form-group profile-edit__email">
                <label for="email">
                  {{ trans.get('profile:edit.email_label') }}
                </label>
                <div v-if="user.email_verified_at">
                  <div>
                    <div>
                      <input
                        v-model="form.email"
                        type="text"
                        id="email"
                        name="email"
                        class="input-text input-text__underline"
                        readonly
                      >
                    </div>
                    <div class="col p-0">
                      <button
                        @click.prevent="$eventHub.$emit('EmailVerificationModalOpen')"
                        class="button button__link--underline p-0"
                      >
                        {{ trans.get('profile:edit.change_button') }}
                      </button>
                    </div>
                  </div>
                  <error-component :errors="formErrors" field='email'></error-component>
                </div>
                <div v-else class="col-12 p-0">
                  <button
                    @click.prevent="$eventHub.$emit('EmailVerificationModalOpen')"
                    class="button button__fill mt-2"
                    dusk="add-email-button"
                  >
                    {{ trans.get('profile:edit.add_email') }}
                    <strong>+{{ globals.settings_email_validation_coins }} {{ trans.get('profile:edit.viluu_coins') }}</strong>
                  </button>
                </div>
              </div>


              <div v-if="globals.profile_phone.edit" class="form-group profile-edit__phone">
                <label for="phone">
                  {{ trans.get('profile:edit.phone_number_label') }}
                </label>
                <div v-if="user.phone_verified_at" class="aaaform-row">
                  <div class="form-row">
                    <div class="col-auto">
                      <input
                        v-model="form.phone_prefix"
                        id="phone_prefix"
                        name="phone_prefix"
                        class="input-text input-text__underline"
                        readonly
                        size="5"
                      >
                    </div>
                    <div class="col-auto col-md">
                      <input
                        v-model="form.phone"
                        id="phone"
                        name="phone"
                        class="input-text input-text__underline"
                        readonly
                        size="10"
                      >
                    </div>
                    <div class="col-12">
                      <button
                        @click.prevent="$eventHub.$emit('PhoneVerificationModalOpen')"
                        class="button button__link--underline"
                      >
                        {{ trans.get('profile:edit.change_button') }}
                      </button>
                    </div>
                  </div>
                  <error-component :errors="formErrors" field='phone'></error-component>
                </div>
                <div v-else class="col-12 p-0">
                  <button
                    @click.prevent="$eventHub.$emit('PhoneVerificationModalOpen')"
                    class="button button__fill mt-2"
                    dusk="add-phone-button"
                  >
                    {{ trans.get('profile:edit.add_number') }}
                    <strong>+{{ globals.settings_phone_validation_coins }} {{ trans.get('profile:edit.viluu_coins') }}</strong>
                  </button>
                </div>
              </div>

              <div v-if="form.location_id" class="form-group profile-edit__location">
                <input-location-component v-model="form.location_id">
                  <label for="location_id">{{ trans.get('profile:edit.location_label') }}</label>
                </input-location-component>
                <error-component :errors="formErrors" field='location_id'></error-component>
              </div>

              <div class="form-group profile-edit__location-show">
                <label for="address_form">{{ trans.get('profile:edit.address_form_label') }}</label>
                <div class="selectdiv">
                  <select
                    v-model="form.address_form"
                    id="address_form"
                    name="address_form"
                    class='form-control'
                  >
                    <option
                      v-for="(v,k) in globals.user.address_forms"
                      :value="k"
                    >
                      {{ v }}
                    </option>
                  </select>
                </div>
                <error-component :errors="formErrors" field='address_form'></error-component>
              </div>

              <div class="form-group profile-edit__about-me">
                <label for="description"> {{ trans.get('profile:edit.about_me_label') }} </label>
                <div
                  v-if="user.description_unchecked"
                  class="pill__fill pill__fill--orange d-inline-block"
                >
                  {{ trans.get('profile:edit.un_verified_state') }}
                </div>

                <textarea
                  v-model="form.description" id="description"
                  name="description" maxlength="300"

                  class="input-textarea input-textarea__underline"
                  :placeholder="trans.get('profile:edit.tell_us_about_you')"
                ></textarea>
                <button class="button button__fill profile-edit__about-me-mobile-save-button">
                  {{ trans.get('profile:edit.save_changes_button') }}
                </button>
                <error-component :errors="formErrors" field='description'></error-component>
              </div>
            </div>
            <div class="offset-xl-2 offset-0 col-12 col-md-6 profile-edit__info mb-5 mb-md-0">

              <div class="profile-edit__attributes">
                <SvgIcon type="lupe"></SvgIcon>
                <label for="preferences">{{ trans.get('profile:edit.info.preferences') }}</label>
                <div class="form-group">
                  <div class="col p-0">
                    <PreferencesEditComponent v-if="loadedEdit" v-model="form.preferences"></PreferencesEditComponent>
                  </div>
                </div>
              </div>

              <label class="mt-4" for="attributes">{{ trans.get('profile:edit.informations_about_me') }}</label>
              <div class="profile-edit__attributes">
                <i class="demo-icon icon-n-heart"></i>
                <label for="attributes[relationship]">{{ trans.get('profile:edit.info.relationship') }}</label>
                <div class="selectdiv selectdiv--underline">
                  <select
                    v-model="form.attributes.relationship"
                    id="attributes[relationship]"
                    name="attributes[relationship]"
                    class="form-control"
                  >
                    <option
                      :key="k"
                      v-for="(v,k) in globals.user.attributes.relationship"
                      :value="k"
                    >
                      {{ v }}
                    </option>
                  </select>
                </div>
                <error-component :errors="formErrors" field='attributes.relationship'></error-component>
              </div>
              <div class="profile-edit__attributes">
                <i class="demo-icon icon-n-child"></i>
                <label for="attributes[has_children]">{{ trans.get('profile:edit.info.children') }}</label>
                <div class="selectdiv selectdiv--underline">
                  <select
                    v-model="form.attributes.has_children"
                    id="attributes[has_children]"
                    name="attributes[has_children]"
                    class="form-control"
                  >
                    <option
                      v-for="(v,k) in globals.user.attributes.has_children"
                      :value="k"
                    >{{ v }}
                    </option>
                  </select>
                </div>
                <error-component :errors="formErrors" field='attributes.has_children'></error-component>
              </div>
              <div class="profile-edit__attributes">
                <i class="demo-icon icon-n-home"></i>
                <label for="attributes[living]">{{ trans.get('profile:edit.info.living') }}</label>
                <div class="selectdiv selectdiv--underline">
                  <select
                    v-model="form.attributes.living"
                    id="attributes[living]"
                    name="attributes[living]"
                    class="form-control"
                  >
                    <option
                      v-for="(v,k) in globals.user.attributes.living"
                      :value="k"
                    >
                      {{ v }}
                    </option>
                  </select>
                </div>
                <error-component :errors="formErrors" field='attributes.living'></error-component>
              </div>
              <div class="profile-edit__attributes">
                <i class="demo-icon icon-n-smoker"></i>
                <label for="attributes[smoker]">{{ trans.get('profile:edit.info.smoker') }}</label>
                <div class="selectdiv selectdiv--underline">
                  <select
                    v-model="form.attributes.smoker"
                    id="attributes[smoker]"
                    name="attributes[smoker]"
                    class="form-control"
                  >
                    <option
                      v-for="(v,k) in globals.user.attributes.smoker"
                      :value="k"
                    >
                      {{ v }}
                    </option>
                  </select>
                </div>
                <error-component :errors="formErrors" field='attributes.smoker'></error-component>
              </div>
                <div>
                    <div class="col-12 text-center mt-5">
                        <button class="button button__fill">
                            {{ trans.get('profile:edit.save_changes_button') }}
                        </button>
                    </div>


                    <div class="row justify-content-center">
                        <div class="col-auto my-4 my-md-0 ">
                            <router-link :to="{name: 'more-settings'}" class="button button__link button__link--underline profile-edit__more">
                                <i class="demo-icon icon-settings-o pr-1"></i>{{ trans.get('profile:edit.more_settings_link') }}
                            </router-link>
                        </div>
                    </div>
                </div>



              <br>
            </div>
          </div>
        </form>
      </div>
    </div>

    <VerificationStatusModal></VerificationStatusModal>
    <VerificationSMSStatusModal></VerificationSMSStatusModal>

    <NewImageModal></NewImageModal>
    <EditImageModal></EditImageModal>
    <PhoneVerificationModal></PhoneVerificationModal>
    <EmailVerificationModal></EmailVerificationModal>
  </div>
</template>

<script>
import CollapsedGalleryComponent from './CollapsedGalleryComponent';
import PreferencesEditComponent from './PreferencesEditComponent';
import NewImageModal from './NewImageModal';
import EditImageModal from './EditImageModal.vue';
import PhoneVerificationModal from '../../../front/components/User/PhoneVerificationModal';
import EmailVerificationModal from '../../../front/components/User/EmailVerificationModal';
import VerificationStatusButton from '../../modules/VerificationStatusButton';
import VerificationStatusModal from '../../modules/VerificationStatusModal';
import VerificationSMSStatusModal from '../../modules/VerificationSMSStatusModal';
import SvgIcon from '../Icon/SvgIcon.vue';

export default {
  name: 'UserEditComponent',
  components: {
    SvgIcon,
    CollapsedGalleryComponent,
    PreferencesEditComponent,
    NewImageModal,
    EditImageModal,
    PhoneVerificationModal,
    EmailVerificationModal,
    VerificationStatusModal,
    VerificationStatusButton,
    VerificationSMSStatusModal
  },
  props: {
    user: Object,
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        phone: null,
        description: null,
        attributes: {
          relationship: '',
          sexual_orientation: '',
          living: null,
          smoker: '',
          has_children: '',
          has_any: true
        },
        preferences: [],
      },
      loadedEdit: false,
      formErrors: {},
    };
  },
  computed: {},
  methods: {
    loadData: function () {
      axios
        .get(zRoute('ajax.user.edit'))
        .then(response => {
          this.fillForm(response.data.data);
          this.loadedEdit = true;
        })
        .catch(error => {
          this.formErrors = error.response.data.errors;
        });
    },
    submitForm: function () {
      this.formErrors = {};
      const user = this.user;
      if (!(this.form.description === (user.description_unchecked || user.description))) {
        this.form.description_unchecked = this.form.description;
      }
      axios
        .put(zRoute('ajax.user.update'), this.form)
        .then(response => {
          this.$store.dispatch('user/load');
          this.$notify({
            group: 'custom-template',
            type: 'info',
            title: this.trans.get('profile:edit.data_saved'),
            duration: 5000,
            data: {},
          });
        })
        .catch(error => {
          this.formErrors = error.response.data.errors;
        });
    },
    fillForm(user) {
      const attributes = user.attributes;
      this.form.name = user.name;
      this.form.email = user.email;

      this.form.phone_prefix = user.phone ? user.phone.slice(0, 3) : null;
      this.form.phone = user.phone ? user.phone.slice(3) : null;

      this.form.location_id = user.location.id;

      this.form.address_form = user.address_form;
      this.form.description = user.description_unchecked || user.description;

      if (user.preferences) {
        this.form.preferences = user.preferences;
      }

      this.form.attributes.relationship = attributes.relationship === null ? '' : attributes.relationship;
      this.form.attributes.sexual_orientation = attributes.sexual_orientation === null ? '' : attributes.sexual_orientation;
      this.form.attributes.living = attributes.living === null ? '' : attributes.living;
      this.form.attributes.smoker = attributes.smoker === null ? '' : attributes.smoker;
      this.form.attributes.has_children = attributes.has_children === null ? '' : attributes.has_children;
      this.form.attributes.has_any = attributes.has_any;
    }
  },
  mounted() {
    this.fillForm(this.user);

    this.loadData();

    this.$eventHub.$on('FreshPhoneEmail', () => {
      const user = this.user;
      this.form.email = user.email;
      this.form.phone_prefix = user.phone ? user.phone.slice(0, 3) : null;
      this.form.phone = user.phone ? user.phone.slice(3) : null;
    });
  }
};
</script>
